import React from 'react';

const AccountPassword = () => {
  return (
    <>
      <p>***...</p>
      <p>Your password for your Isibute account. For security, do not reuse on other websites.</p>
    </>
  );
};

export default AccountPassword;